// The jenkins build will replace this with the version number and overwrite the version.ts file
export const app_version='1.3.3.55';
